import { render } from "./achieveAdd.vue?vue&type=template&id=a7aa06c6&scoped=true"
import script from "./achieveAdd.vue?vue&type=script&lang=js"
export * from "./achieveAdd.vue?vue&type=script&lang=js"

import "./achieveAdd.vue?vue&type=style&index=0&id=a7aa06c6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7aa06c6"]])

export default __exports__